import React from 'react';
import classnames from 'classnames';

import PlusCircleSvg from './assets/js/plusCircle.svg';
import styles from './styles.css';

interface Prams {
  handleClick: () => void;
  text?: string;
  mobileText?: string;
  showText?: boolean;
}

export const MoreButton = ({handleClick, text, showText, mobileText}: Prams) => {
  return (
    <button
      aria-label="show related"
      data-modal-opener-button
      className={classnames(styles.relatedButton, showText && styles.showText)}
      onClick={handleClick}
    >
      <span className={styles.text}>{text}</span>
      <span className={styles.mobileText}>{mobileText}</span>
      <PlusCircleSvg />
    </button>
  );
};
